/**
 * @generated SignedSource<<4256f9beec1cdeaa0a9f1c768d836a3b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useStatusUpdatesAutomationNudgeAction_user$data = {
  readonly emails: ReadonlyArray<{
    readonly isPrimary: boolean | null;
    readonly value: string | null;
  } | null> | null;
  readonly id: string | null;
  readonly " $fragmentType": "useStatusUpdatesAutomationNudgeAction_user";
};
export type useStatusUpdatesAutomationNudgeAction_user$key = {
  readonly " $data"?: useStatusUpdatesAutomationNudgeAction_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"useStatusUpdatesAutomationNudgeAction_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useStatusUpdatesAutomationNudgeAction_user",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "AtlassianUserEmail",
      "kind": "LinkedField",
      "name": "emails",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        },
        {
          "kind": "ScalarField",
          "name": "isPrimary"
        }
      ]
    }
  ],
  "type": "AtlassianUser"
};

(node as any).hash = "bd815d5bb997711ba777b0f37c0a9cf7";

export default node;
